import * as mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

export default {
  namespaced: true,
  state () {
    return {
      residence: undefined,
      corporateName: undefined,
      tradeName: undefined,
      document: undefined,
      address: {
        street: undefined,
        postalCode: undefined,
        town: undefined,
        city: undefined,
        country: undefined
      },
      registrationData: {
        book: undefined,
        folio: undefined,
        sheet: undefined,
        section: undefined,
        volume: undefined,
        mercantileRegistry: undefined,
        additionalRegistrationData: undefined
      },
      medium: {
        email: undefined,
        fax: undefined,
        phone: undefined,
        web: undefined,
        name: undefined,
        additionalContactDetails: undefined
      }
    }
  },
  mutations,
  actions,
  getters,
  modules: {

  }
}
